// 학교 목록 상수
export const SCHOOL_LIST = [
  '테스트 학교',
  '고금초등학교',
  '군외초등학교',
  '금당초등학교',
  '금일동초등학교',
  '금일초등학교',
  '넙도초등학교',
  '넙도초등학교 서리분교',
  '노화북초등학교',
  '노화중앙초등학교',
  '노화초등학교',
  '보길동초등학교',
  '보길초등학교',
  '생영초등학교',
  '소안초등학교',
  '신지동초등학교',
  '신지초등학교',
  '약산초등학교',
  '완도중앙초등학교',
  '완도초등학교',
  '청산초등학교',
  '청산초등학교 모도분교',
  '청해초등학교',
  '화흥초등학교'
];

// 기본 학교
export const DEFAULT_SCHOOL = '테스트 학교';